import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { Typography } from '@finam/web-ui-kit';
import styled from 'styled-components';
export var Form = styled.form(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: transparent;\n"])));
export var Description = styled(Typography).attrs({
  variant: 'body14'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 32px;\n"])));
export var FormRow = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n"])));
export var FooterButtons = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: auto;\n  padding-top: 40px;\n"])));